"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _require = require('../analytics/role.constant'),
    ANALYTICS_EDGE_ROLES = _require.ANALYTICS_EDGE_ROLES;

var LABEL = {
  NODE: {
    // organizations
    GLOBAL: 'GLOBAL',
    // there should only be ONE
    CAMPUS: 'CAMPUS',
    COLLEGE: 'COLLEGE',
    DIVISION: 'DIVISION',
    DEPARTMENT: 'DEPARTMENT',
    DOMAIN: 'DOMAIN',
    COLLECTION: 'COLLECTION',
    SERVICE: 'SERVICE',
    PROGRAM: 'PROGRAM',
    PARTY: 'PARTY',
    TENANT: 'TENANT',
    UNIT: 'UNIT',
    GROUP: 'GROUP',
    DISTRICT: 'DISTRICT',
    FACILITY: 'FACILITY',
    CENTER_OF_EXCELLENCE: 'CENTER_OF_EXCELLENCE',
    // org for rolling up programs across campus/domain
    USER: 'USER',
    EMPLOYEE: 'EMPLOYEE',
    // locations
    BUILDING: 'BUILDING',
    FLOOR: 'FLOOR',
    ROOM: 'ROOM',
    // assessment
    PROGRAM_FLEX: 'PROGRAM_FLEX',
    LAB_HAZARD: 'LAB_HAZARD',
    UNIT_RISK: 'UNIT_RISK',
    BUA: 'BUA',
    RESPIRATOR: 'RESPIRATOR',
    FLEX_CONFIG: 'FLEX_CONFIG',
    LAB_HAZARD_CONFIG: 'LAB_HAZARD_CONFIG',
    UNIT_RISK_CONFIG: 'UNIT_RISK_CONFIG',
    BUA_CONFIG: 'BUA_CONFIG',
    PESTICIDE_CONFIG: 'PESTICIDE_CONFIG',
    RESPIRATOR_CONFIG: 'RESPIRATOR_CONFIG',
    // inspect
    REPORT: 'REPORT',
    QUESTIONNAIRE_SERIES: 'QUESTIONNAIRE_SERIES',
    QUESTIONNAIRE_TEMPLATE: 'QUESTIONNAIRE_TEMPLATE',
    INVENTORY: 'INVENTORY',
    STORE: 'STORE',
    STORE_ACCOUNT: 'STORE_ACCOUNT',
    // incident-mgmt
    INCIDENT_QUESTIONNAIRE: 'INCIDENT_QUESTIONNAIRE',
    INCIDENT_REPORT: 'INCIDENT_REPORT',
    WORKSTRONG_FILE: 'WORKSTRONG_FILE',
    WORKSTRONG_FEATURE: 'WORKSTRONG_FEATURE',
    // pesticide
    OPERATOR_GROUP: 'OPERATOR_GROUP',
    PESTICIDE_USE: 'PESTICIDE_USE'
  },
  EDGE: _objectSpread(_objectSpread({}, ANALYTICS_EDGE_ROLES), {}, {
    // Roles Specific to Analytics
    AFFILIATED: 'AFFILIATED',
    SYSTEM_ROLE: 'SYSTEM_ROLE',
    IS_A: 'IS_A',
    APPOINTMENT_IN: 'APPOINTMENT_IN',
    DOCUMENT: 'DOCUMENT',
    FEATURE: 'FEATURE',
    LOCATED: 'LOCATED',
    VERSION: 'VERSION',
    APPROVED: 'APPROVED',
    CERTIFIED: 'CERTIFIED',
    COMPLETED: 'COMPLETED',
    ACKNOWLEDGED: 'ACKNOWLEDGED',
    LOCATION: 'LOCATION',
    DELEGATE: 'DELEGATE',
    MEMBER: 'MEMBER',
    OWNER: 'OWNER',
    COLLEAGUE: 'COLLEAGUE',
    CONTACT: 'CONTACT',
    INVENTORY_MANAGER: 'INVENTORY_MANAGER',
    // inventory -> BELONGS_TO -> store
    BELONGS_TO: 'BELONGS_TO',
    ADMINISTERED_BY: 'ADMINISTERED_BY',
    STORE_MANAGER: 'STORE_MANAGER',
    RESPONSIBLE_PERSON: 'RESPONSIBLE_PERSON',
    PROGRAM_ADMIN: 'PROGRAM_ADMIN',
    DISTRICT_ADMIN: 'DISTRICT_ADMIN',
    INSPECTOR: 'INSPECTOR',
    INSPECT_ADMIN: 'INSPECT_ADMIN',
    SUBJECT: 'SUBJECT',
    BIOSAFETY_ADMIN: 'BIOSAFETY_ADMIN',
    COLLECTION_ADMIN: 'COLLECTION_ADMIN',
    EHS_DEPARTMENT_ADMIN: 'EHS_DEPARTMENT_ADMIN',
    FLEX_EVALUATOR: 'FLEX_EVALUATOR',
    FLEX_CONSULTANT: 'FLEX_CONSULTANT',
    WAIVER_ADMIN: 'WAIVER_ADMIN',
    IBC_MEMBER: 'IBC_MEMBER',
    LAB_HAZARD_ADMIN: 'LAB_HAZARD_ADMIN',
    PPE_COORDINATOR: 'PPE_COORDINATOR',
    SAFETY_COORDINATOR: 'SAFETY_COORDINATOR',
    PROFILE_ADMIN: 'PROFILE_ADMIN',
    ROLE_MANAGER: 'ROLE_MANAGER',
    UNIT_RISK_ADMIN: 'UNIT_RISK_ADMIN',
    RESPIRATOR_ADMIN: 'RESPIRATOR_ADMIN',
    WAIVER_OBSERVER: 'WAIVER_OBSERVER',
    ACCOUNT_MANAGER: 'ACCOUNT_MANAGER',
    LOCATION_MANAGER: 'LOCATION_MANAGER',
    NURSE_MANAGER: 'NURSE_MANAGER',
    UNIT_MANAGER: 'UNIT_MANAGER',
    CHILD_ORGANIZATION: 'CHILD_ORGANIZATION',
    NOTIFICATION_MANAGER: 'NOTIFICATION_MANAGER',
    PROCEDURES_ADMIN: 'PROCEDURES_ADMIN',
    AGENDA_PROCEDURES_TEMPLATE_ADMIN: 'AGENDA_PROCEDURES_TEMPLATE_ADMIN',
    FIELD_PROCEDURES_TEMPLATE_ADMIN: 'FIELD_PROCEDURES_TEMPLATE_ADMIN',
    LOTO_PROCEDURES_TEMPLATE_ADMIN: 'LOTO_PROCEDURES_TEMPLATE_ADMIN',
    MEDICAL_PROCEDURES_TEMPLATE_ADMIN: 'MEDICAL_PROCEDURES_TEMPLATE_ADMIN',
    SPH_PROCEDURES_TEMPLATE_ADMIN: 'SPH_PROCEDURES_TEMPLATE_ADMIN',
    SOP_PROCEDURES_TEMPLATE_ADMIN: 'SOP_PROCEDURES_TEMPLATE_ADMIN',
    WPVP_PROCEDURES_TEMPLATE_ADMIN: 'WPVP_PROCEDURES_TEMPLATE_ADMIN',
    AGENDA_PROCEDURES_ADMIN: 'AGENDA_PROCEDURES_ADMIN',
    FIELD_PROCEDURES_ADMIN: 'FIELD_PROCEDURES_ADMIN',
    LOTO_PROCEDURES_ADMIN: 'LOTO_PROCEDURES_ADMIN',
    MEDICAL_PROCEDURES_ADMIN: 'MEDICAL_PROCEDURES_ADMIN',
    SPH_PROCEDURES_ADMIN: 'SPH_PROCEDURES_ADMIN',
    SOP_PROCEDURES_ADMIN: 'SOP_PROCEDURES_ADMIN',
    WPVP_PROCEDURES_ADMIN: 'WPVP_PROCEDURES_ADMIN',
    INITIAL_REVIEWER: 'INITIAL_REVIEWER',
    FINAL_REVIEWER: 'FINAL_REVIEWER',
    RADIATION_ADMIN: 'Radiation Admin',
    RADIATION_EMAIL_LIST: 'Radiation Email List',
    RADIATION_INSPECTOR: 'Radiation Inspector',
    CONTROL_AREA_ADMIN: 'CONTROL_AREA_ADMIN',
    CHEMICAL_ADMIN: 'CHEMICAL_ADMIN',
    CHEMICAL_ADMIN_READ_ONLY: 'CHEMICAL_ADMIN_READ_ONLY',
    CHEMICAL_INFORMATICS: 'CHEMICAL_INFORMATICS',
    GROUP: 'GROUP',
    MEDICAL_ADMIN: 'MEDICAL_ADMIN',
    RESPIRATOR_PROGRAM_ADMIN: 'RESPIRATOR_PROGRAM_ADMIN',
    SYSTEM_CONTROL_AREA_ADMIN: 'SYSTEM_CONTROL_AREA_ADMIN',
    SERVICE_DESK: 'SERVICE_DESK',
    CONFIGURATION_MANAGER: 'CONFIGURATION_MANAGER',
    RSS_DATA_ADMIN: 'RSS_DATA_ADMIN',
    BSAS_ADMIN: 'BSAS_ADMIN',
    CLI_ADMIN: 'CLI_ADMIN',
    DRONES_ADMIN: 'DRONES_ADMIN',
    DRONES_TENANT_ADMIN: 'DRONES_TENANT_ADMIN',
    NFPA_ADMIN: 'NFPA_ADMIN',
    // pesticide
    IPM_COORDINATOR: 'IPM_COORDINATOR',
    LIBRARY_MANAGER: 'LIBRARY_MANAGER',
    // incident-mgmt
    CLAIMS_ANALYST: 'CLAIMS_ANALYST',
    INJURED_PERSON: 'INJURED_PERSON',
    REPORTER: 'REPORTER',
    SUPERVISOR: 'SUPERVISOR',
    INVESTIGATOR: 'INVESTIGATOR',
    // analytics
    AWAY_ADMIN: 'AWAY_ADMIN',
    EFR_ADMIN: 'EFR_ADMIN',
    INSPECT_ANALYTICS: 'INSPECT_ANALYTICS',
    MONITOR_ADMIN: 'MONITOR_ADMIN',
    TRAINING_ADMIN: 'TRAINING_ADMIN',
    WASTE_ADMIN: 'WASTE_ADMIN',
    WASTE_STAFF: 'WASTE_STAFF',
    WSSP_PROCEDURES_ADMIN: 'WSSP_PROCEDURES_ADMIN',
    // workstrong
    PARTICIPANT: 'PARTICIPANT',
    WORKSTRONG_COORDINATOR: 'WORKSTRONG_COORDINATOR',
    WORKSTRONG_TPA: 'WORKSTRONG_TPA',
    COE_ADMIN: 'COE_ADMIN'
  }),
  EDGE_TYPE: {
    EVENT: 'EVENT',
    ROLE: 'ROLE',
    OTHER: 'OTHER'
  }
};
module.exports = _objectSpread({}, LABEL);